import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o } from "vue";
//#region ../src/icons/shield-off.vue
var s = {
	name: "DtIconShieldOff",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, c = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], l = ["clip-path"], u = ["id"];
function d(e, t, n, s, d, f) {
	return o(), r("svg", {
		"aria-label": n.ariaLabel,
		class: a([f.iconSizeClass, "d-icon d-icon--shield-off"]),
		"data-qa": f.dataQA,
		"aria-hidden": f.ariaHidden,
		role: "img",
		"data-name": "Shield Off",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [i("g", { "clip-path": `url(#${e.uniqueID}a)` }, [...t[0] || (t[0] = [i("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M.646.646a.5.5 0 0 1 .708 0L2.71 2.004l.016.015L9.16 8.454a.575.575 0 0 1 .005.005l2.188 2.187a.5.5 0 0 1-.708.708L8.82 9.527a10.645 10.645 0 0 1-2.587 1.915.5.5 0 0 1-.457.005L6 11l-.224.447h-.001l-.004-.002-.01-.006-.038-.02a10.362 10.362 0 0 1-.613-.355c-.39-.244-.914-.603-1.44-1.063C2.64 9.101 1.5 7.723 1.5 6V2.5a.5.5 0 0 1 .058-.235l-.912-.911a.5.5 0 0 1 0-.708ZM2.5 3.207V6c0 1.277.86 2.4 1.83 3.249A10.341 10.341 0 0 0 6 10.43a9.643 9.643 0 0 0 2.113-1.61L2.5 3.206ZM5.825.532a.5.5 0 0 1 .35 0l4 1.5a.5.5 0 0 1 .325.468v3.503a3.952 3.952 0 0 1-.178 1.145.5.5 0 1 1-.955-.296 2.95 2.95 0 0 0 .133-.854V2.846L6 1.534l-1.405.524a.5.5 0 1 1-.35-.936l1.58-.59Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 8, l), i("defs", null, [i("clipPath", { id: `${e.uniqueID}a` }, [...t[1] || (t[1] = [i("path", {
		fill: "#fff",
		d: "M0 0h12v12H0z"
	}, null, -1)])], 8, u)])], 10, c);
}
var f = /* @__PURE__ */ n(s, [["render", d]]);
//#endregion
export { f as default };

//# sourceMappingURL=shield-off.js.map